import { connect } from 'react-redux';
import { getStrugglingAdvancedGoalForMeasure } from '@amplify/struggling-advanced-goal';
import { progressGoalSetLookerEvent } from '../../../../api/lrs/shared/lrsActions';
import { saveStudentGoalReading } from '../../../../api/studentGoals/reading/studentGoalsActions';
import { selectors } from '../../../../root/reading/root';
import ZonesOfGrowthTable from '../../../../features/progress/shared/zonesOfGrowth/ZonesOfGrowthTable';
import { SS_URL } from '../../../../constants/reading/ApiConstants';
import SkillCell from '../../../../components/cell/reading/Cells';
import CommonCellBuilder from '../../../../components/cell/reading/CommonCellBuilder';
import { DYSLEXIA_MEASURES } from '../../../../constants/reading/MeasuresConstants';
import { ZOG } from '../../../../constants/shared/CommonConstants';

const appSpecificParams = {
    getStrugglingAdvancedGoalForMeasure,
    dyslexiaMeasures: DYSLEXIA_MEASURES,
    ssUrl: SS_URL,
    SkillCell,
    CommonCellBuilder,
    tableTitle: ZOG.ZONES_OF_GROWTH,
};

const mapStateToProps = state => ({
    location: selectors.getLocation(state),
    resultsByGrades: selectors.getStudentsZoGDataByGrades(state),
    currentSchoolYear: selectors.getCurrentSchoolYear(state),
    isDemoModeOn: selectors.getIsDemoModeOn(state),
    gradeToMeasureMapper: selectors.getGradeToMeasureMapper(state),
    appSpecificParams,
});

const mapDispatchToProps = dispatch => ({
    saveStudentGoal: goal => {
        dispatch(saveStudentGoalReading(goal));
    },
    goalSetLookerEvent: ({ selectedPeriod, measure, goalScore, prevGoalScore, growthRatePrev }) => {
        dispatch(
            progressGoalSetLookerEvent({
                selectedPeriod,
                measure,
                goalScore,
                prevGoalScore,
                growthRatePrev,
            }),
        );
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ZonesOfGrowthTable);
